export default "__VITE_ASSET__lA4H6Fiy__"